import DesktopPNG from '@assets/Desktop.png';
import LtPng from '@assets/lt.png';
import MobilePNG from '@assets/Mobile.png';
import RuPng from '@assets/ru.png';
import SimulatorPNG from '@assets/Simulator Wheel Blue.png';
import TabletPNG from '@assets/Tablet.png';
import UkPng from '@assets/uk.png';
import VRPNG from '@assets/VR Headset Outline.png';
import { Language, Type } from '@shared/enum';

export const routes = {
    login: `/login`,
    reset: `/reset`,
    changePassword: `/change-password`,
    home: `/home`,
    settings: `/settings`,
    learning: `/learning`,
    termsConditions: `/terms-and-conditions`,
    notifications: `/notifications`,
    help: `/help`,
    courseDetail: `/learning/:id`,
    tournaments: `/tournaments`,
    tournament: `/tournament/:id`,
    error404: `/404`,
    error500: `/500`,
    assignments: `/assignments`,
    assignment: `/assignments/crud`,
    assignmentDetail: `/assignments/crud/:id`,
    assignmentManage: `/assignments/manage/:id`,
    performance: `/performance`,
    managementUsers: `/management/users`,
    managementUserCreate: `/management/users/create`,
    managementUserEdit: `/management/users/:id/edit`,
    managementGroups: `/management/groups`,
    managementGroupCreate: `/management/groups/create`,
    managementGroupEdit: `/management/groups/:id/edit`,
};

export const defaultRouterIdKey = ':id';
export const defaultTournamentItemsPerPage = 12;
export const defaultTournamentItemsPerCompletedPage = 10;
export const avatarURL = 'https://api.dicebear.com/9.x/initials/svg?seed=???';
export const defaultTournamentTimerEnding = 3600;
export const defaultTournamentNewSessionFlashing = 30000;

export const languageData: Record<
    Language,
    {
        label: string;
        shortLabel: Language;
        img: string;
        dateTimeFormat: string;
        dateFormat: string;
        yearMonthDayFormat: string;
        monthDayFormat: string;
        monthDayYearFormat: string;
        hoursMinutesFormat: string;
        dayMonthYearTimeFormat: string;
    }
> = {
    [Language.EN]: {
        label: 'English',
        shortLabel: Language.EN,
        img: UkPng,
        dateTimeFormat: 'yyyy-MM-dd HH:mm',
        dateFormat: 'yyyy.MM.dd',
        monthDayFormat: 'MMMM d',
        monthDayYearFormat: 'MMMM d, yyyy',
        yearMonthDayFormat: 'yyyy MMM. dd',
        hoursMinutesFormat: 'HH:mm',
        dayMonthYearTimeFormat: 'MMM. dd, yyyy HH:mm',
    },
    [Language.LT]: {
        label: 'Lietuvių',
        shortLabel: Language.LT,
        img: LtPng,
        dateTimeFormat: 'yyyy-MM-dd HH:mm',
        dateFormat: 'yyyy.MM.dd',
        monthDayFormat: 'MMMM d',
        monthDayYearFormat: 'MMMM d, yyyy',
        yearMonthDayFormat: 'yyyy MMM. dd',
        hoursMinutesFormat: 'HH:mm',
        dayMonthYearTimeFormat: 'dd MMM yyyy HH:mm',
    },
    [Language.RU]: {
        label: 'Русский',
        shortLabel: Language.RU,
        img: RuPng,
        dateTimeFormat: 'yyyy-MM-dd HH:mm',
        dateFormat: 'yyyy.MM.dd',
        monthDayFormat: 'MMMM d',
        monthDayYearFormat: 'MMMM d, yyyy',
        yearMonthDayFormat: 'yyyy MMM. dd',
        hoursMinutesFormat: 'HH:mm',
        dayMonthYearTimeFormat: 'dd MMM yyyy HH:mm',
    },
};
export const defaultCounterMax = 2;

export const devicesData: Record<
    Type,
    Array<{
        label: string;
        img: string;
    }>
> = {
    [Type._360]: [
        {
            label: 'simulator',
            img: SimulatorPNG,
        },
    ],
    [Type._3D]: [
        {
            label: 'VR headset',
            img: VRPNG,
        },
    ],
    [Type._Other]: [
        {
            label: 'computer',
            img: DesktopPNG,
        },
        {
            label: 'tablet',
            img: TabletPNG,
        },
        {
            label: 'mobile',
            img: MobilePNG,
        },
    ],
};
